import axios from "axios";
import dotenv from "dotenv";
dotenv.config();

export default () => {
  if (process.env.NODE_ENV === "development") {
    return axios.create({
      baseURL: "http://localhost:8081"
    });
  } else {
    return axios.create({
      baseURL: "https://api.knottytie.com"
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/Api.js